export enum IOrderTransVid {
    None = 0,
    Public = 1,
    Car = 2,
}